export const SOCIAL_LOGIN_ERROR_PARAM = 'socialLoginError';

export const SOCIAL_LOGIN_ERRORS = {
  NOT_REGISTERED: 'notRegisteredError',
  ALREADY_REGISTERED_PLEASE_LOGIN: 'alreadyRegisteredPleaseLogin',
  EMAIL_ALREADY_EXISTS_USE_PASSWORD: 'emailAlreadyExistsUseEmailAndPassword',
  UNEXPECTED_ERROR: 'unexpectedError',
  EMAIL_REQUIRED: 'emailRequiredForSocialLogin',
  EMAIL_REQUIRED_FOR_SIGNUP: 'emailRequiredForSocialSignUp',
} as const;

export type SocialLoginErrorType = (typeof SOCIAL_LOGIN_ERRORS)[keyof typeof SOCIAL_LOGIN_ERRORS];
